import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { SmartHomeComponentsState } from './smart-home-components.state';
import { SmartHomeComponentsActions } from './smart-home-components.actions';

export const initSmartHomeComponentsState: SmartHomeComponentsState = {
  smartHomeComponents: [],
  error: null,
  loaded: false,
  loading: false,
};

export const smartHomeComponentsReducer: ActionReducer<
  SmartHomeComponentsState,
  Action
> = createReducer(
  initSmartHomeComponentsState,

  on(
    SmartHomeComponentsActions.getSmartHomeComponents,
    SmartHomeComponentsActions.updateSmartHomeComponents,
    (state): SmartHomeComponentsState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    SmartHomeComponentsActions.getSmartHomeComponentsError,
    SmartHomeComponentsActions.updateSmartHomeComponentsError,
    (state, { error }): SmartHomeComponentsState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  ),

  on(
    SmartHomeComponentsActions.getSmartHomeComponentsSuccess,
    SmartHomeComponentsActions.updateSmartHomeComponentsSuccess,
    (state, { smartHomeComponents }): SmartHomeComponentsState => ({
      ...state,
      smartHomeComponents,
      loading: false,
      loaded: true,
      error: null,
    })
  )
);
